import React, { useState, useEffect } from "react";
import { useAccount, useFeeData } from "wagmi";
import { useNavigate } from "react-router-dom";
import Loading from "../Loading";
import axios from "axios";

import "flowbite";
import AdminPrifile from "./AdminProfile";
import { ToastContainer, toast } from "react-toastify";
import { IoIosAddCircleOutline } from "react-icons/io";
import { IoIosAddCircle } from "react-icons/io";
import { useSigner } from "wagmi";

import { SubscriptionAddress } from "../Contracts/Subscription";
import { SubscriptionAbi } from "../Contracts/Subscription";
import { ethers } from "ethers";
import CreatePackage from "./CreatePackage";
import { MdDelete } from "react-icons/md";
import { AiFillEdit } from "react-icons/ai";
import UpdatePackage from "./UpdatePackage";
import DeletePackage from "./DeletePackage";

const privateKey = process.env.REACT_APP_ADMIN_PRIVATEkEY;
const NODE_URL = process.env.REACT_APP_NODE_URL;

const customProvider = new ethers.providers.JsonRpcProvider(NODE_URL);
const customSigner = new ethers.Wallet(privateKey, customProvider);

const Packages = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const { BigNumber } = require("ethers");
  const [plan, setPlans] = useState([]);
  const [boxes, setBoxes] = useState([]);
  const [popCreateBox, setPopCreateBox] = useState(false);
  const [popUpdateBox, setPopUpdateBox] = useState(false);
  const [popUpdateBoxIndex, setPopUpdateBoxIndex] = useState("");
  const [popRemoveBoxIndex, setPopRemoveBoxIndex] = useState("");
  const [popDeleteBox, setPopDeleteBox] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [boxUpdated, setBoxUpdated] = useState(false);

  const boxIsUpdated = () => {
    // console.log('njhjgjhgjhgmjgjkghjgj')
    setBoxUpdated(!boxUpdated)
  };
  const deleteBoxPopHandeler = () => {
    popDeleteBox ? setPopDeleteBox(false) : setPopDeleteBox(true);
  };

  const createBoxPopHandeler = () => {
    popCreateBox ? setPopCreateBox(false) : setPopCreateBox(true);
  };

  const updateBoxPopHandeler = (index) => {
    popUpdateBox ? setPopUpdateBox(false) : setPopUpdateBox(true);
  };

  const { address } = useAccount();

  const { data: signer } = useSigner();
  let contract;
  let customContract;

  if (signer) {
    contract = new ethers.Contract(
      SubscriptionAddress,
      SubscriptionAbi,
      signer
    );
  }

  if (customSigner) {
    customContract = new ethers.Contract(
      SubscriptionAddress,
      SubscriptionAbi,
      customSigner
    );
  }
  // console.log("Subscription", customContract);

  // console.log("Boxes", boxes);
  const getPlans = async () => {
    try {
      await axios
        .get(`${process.env.REACT_APP_SERVER_URL}/payment-history`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }).then(async()=>{
          setIsLoading(true);

    const totalAgents = await customContract?.totalSubscriptionPlans();
    const bigNumber = BigNumber.from(totalAgents);
    const bigNumberString = bigNumber.toString();
    // console.log("bignmber", bigNumberString);
    // setPlans([]);
    let c = [];
    for (var i = 0; i < bigNumberString; i++) {
      await customContract?.getSubscriptionPlanDetails(i).then((res) => {
        // console.log("Result", res);
        const price = BigNumber.from(res.price);
        const prices = price.toString();
        const wei = ethers.utils.formatEther(prices.toString());

        c.push({
          price: prices,
          storage: ethers.BigNumber.from(res.storageAvailable).toString(),
        });
      });
    }
    setPlans(c);
    setIsLoading(false);

        })
    } catch (error) {
      setIsLoading(false);
      console.error("Error logging in:", error);
      localStorage.setItem("reload", true);
      navigate("/#");
    }
    
  };

  useEffect(() => {
    if (customSigner) {
      getPlans();
    }
  }, [customSigner, boxUpdated]);

  return (
    <div style={{ opacity: 1 }} className="relative z-50">
      <div className="antialiased bg-[#212445]  w-full min-h-screen text-slate-300 relative py-4">
        <div className="grid grid-cols-12 mx-auto gap-2 sm:gap-4 md:gap-6 lg:gap-10 xl:gap-14 max-w-7xl my-10 px-2">
          <AdminPrifile />

          <div
            id="packagesList"
            className="bg-[#151c2c] col-span-9 rounded-lg p-6 my-10 relative z-30"
          >
            <div>
              <div className="flex justify-between items-center">
                <h1 className="font-bold py-4 uppercase">Package Details</h1>
                {/* <span
                  onClick={createBoxPopHandeler}
                  className="font-bold py-4 text-2xl cursor-pointer "
                >
                  <IoIosAddCircle />
                </span> */}
              </div>
              <div className="grid md:grid-cols-2 grid-cols-1 gap-5 md:px-28 px-4 py-10 justify-around">
                {" "}
                {plan?.map((item, index) => (
                  <div
                    className="bg-[#23314c] rounded-lg p-4 cursor-pointer w-fill"
                    key={index}
                  >
                    <div className="flex justify-between">
                      <h1 className="font-bold  text-white text-xl">
                        {index == 0
                          ? "Small"
                          : index == 1
                          ? "Medium"
                          : index == 2
                          ? "Large"
                          : "New Box"}
                      </h1>
                      <span
                        onClick={() => {
                          updateBoxPopHandeler();
                          setPopUpdateBoxIndex(index);
                        }}
                      >
                        <AiFillEdit />
                      </span>
                    </div>
                    <h1 className="text-lg font-extrabold text-transparent bg-clip-text bg-gradient-to-b py-2 from-[#7789b8] to-[#8B53E8]">
                      {ethers.utils.formatEther(item.price)} Matic
                    </h1>
                    <div className="flex justify-between items-center">
                      <h1 className="text-lg font-extrabold text-transparent bg-clip-text bg-gradient-to-b py-2 from-[#7789b8] to-[#8B53E8]">
                        {item.storage/1024} Mb
                      </h1>
                      {/* <span
                        onClick={() => {
                          deleteBoxPopHandeler();
                          setPopRemoveBoxIndex(index);
                        }}
                        className="text-lg font-extrabold text-red-600 p-0.5 rounded-md bg-gray-200"
                      >
                        <MdDelete />
                      </span> */}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        onClick={() => {
          localStorage.setItem("reload", true);
          navigate("/#");
        }}
        className="absolute bottom-4 left-4 text-white bg-black px-3 py-1 rounded-sm cursor-pointer"
      >
        Logout
      </div>
      {popCreateBox ? (
        <CreatePackage closeCreateBox={createBoxPopHandeler} />
      ) : (
        ""
      )}

      {popDeleteBox ? (
        <DeletePackage
          closeRemoveBox={deleteBoxPopHandeler}
          index={popRemoveBoxIndex}
        />
      ) : (
        ""
      )}

      {popUpdateBox ? (
        <UpdatePackage
          update = {boxIsUpdated}
          closeCreateBox={updateBoxPopHandeler}
          index={popUpdateBoxIndex}
        />
      ) : (
        ""
      )}
      <Loading isLoading={isLoading} />

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </div>
  );
};

export default Packages;
